import styled, { css } from 'styled-components'

interface SideBarProps {
  displaySidebar?: boolean
}
interface ItemWrapperProps {
  displaySidebar: boolean
}

export const SidebarWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  font-size: 0.9rem;
`

export const SidebarToggler = styled.button<SideBarProps>`
  cursor: pointer;
  display: ${({ displaySidebar }) => (displaySidebar ? 'block' : 'none')};
  @media (max-width: 468px) {
    display: block;
  }
`

// SidebarItem styles
export const ItemsList = styled.ul<{ isMobile?: boolean }>`
  list-style: none;
  padding: 0rem 0.5rem 0rem 0rem;

  ${(props) =>
    props.isMobile &&
    css`
      width: 100%;
    `}
`

export const ItemContainer = styled.li<{ active?: boolean }>`
  display: flex;
  margin-top: 1rem;
  width: 100%;
  padding: 1rem;
  border-radius: 0.2rem;
  cursor: pointer;
  transition: border-left 0.5s;

  white-space: nowrap;

  &:hover {
    border-left: ${({ theme }) => `0.4rem solid rgb(${theme.primary.base})`};

    a {
      svg {
        margin-left: -0.4rem !important;
      }
    }
  }

  ${(props) =>
    props.active &&
    css`
      border-left: ${({ theme }) => `0.4rem solid rgb(${theme.primary.base})`};

      a {
        svg {
          margin-left: -0.4rem !important;
        }
      }
    `}

  a {
    display: flex;
    align-items: center;
    width: 100%;

    svg {
      margin: -0.3rem 0.5rem 0 0;
    }
  }

  @media only screen and (min-width: 800px) {
    a {
      svg {
        margin: 0 auto;
      }
    }
  }
`

export const ItemWrapper = styled.div<ItemWrapperProps>`
  display: flex;
  align-items: center;
  color: ${({ theme }) => `rgba(${theme.grayscale[100]}, 0.9)`};
  justify-content: flex-start !important;

  .beta {
    display: inline-block;
    margin-left: 0.5rem;
    border-radius: 2px;
    align-items: center;
    padding: 2px;
    font-family: 'Montserrat';
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    width: 42px;
    height: 20px;
    background-color: ${({ theme }) =>
      theme.isDark ? 'rgba(8, 137, 198, 1)' : 'rgba(50, 183, 246, 0.3)'};
    color: ${({ theme }) => (theme.isDark ? 'rgba(182, 229, 252, 1)' : 'rgba(5, 81, 117, 1)')};
  }
`

export const ItemActive = styled.div`
  margin-right: 0.5rem;
  background: ${({ theme }) => `rgb(${theme.component.background})`};
  width: 10px;
  border-radius: 0px 4px 4px 0px;
  &.active {
    background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
  }
`

export const ItemName = styled.span<SideBarProps>`
  //margin-left: ${({ displaySidebar }) => (displaySidebar ? '0.5rem' : '0')};
  display: ${({ displaySidebar }) => (displaySidebar ? 'block' : 'none')};
  text-transform: capitalize;
`

export const LifetimeSidebarBadge = styled.div<SideBarProps>`
  display: flex;
  justify-content: center !important;
  justify-self: flex-end;
  align-self: center;
  margin: 0 auto;
  padding: 0.2rem;
  padding-bottom: 2rem;

  .badgeContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.55rem;

    width: 90%;
    height: 14rem;

    background: rgba(5, 81, 117, 1);
    color: rgba(255, 255, 255, 1);

    padding: 1rem;
    border-radius: 0.5rem;

    svg {
      width: 2rem;
      height: 2rem;
      align-self: flex-start;
    }

    @media screen and (min-width: 800px) {
      width: 4.3rem;
      height: 4.3rem;

      svg {
        align-self: initial;
      }
    }
  }

  .badgeText {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    text-align: left;

    padding: 0;

    strong {
      font-size: 1.125rem;
      font-weight: 700;
    }

    span {
      font-size: 0.75rem;
      font-weight: 500;
    }

    @media screen and (min-width: 800px) {
      display: none;
    }
  }
`
// Sidebar Container
export const SidebarContainer = styled.div<SideBarProps>`
  position: fixed !important;
  left: 0px !important;
  top: 0px !important;
  z-index: 20;
  //padding: 0.5rem 0.25rem;
  width: ${({ displaySidebar }) => (displaySidebar ? '15rem' : '5rem')};
  height: 100vh;
  background: ${({ theme }) => `rgb(${theme.component.background})`};
  transition: width 350ms ease;
  border: ${({ theme }) => `1px solid rgb(${theme.component.accent})`};
  border-radius: 0px 12px 12px 0px;
  overflow-x: hidden;
  ${({ displaySidebar }) => displaySidebar && 'box-shadow: 8px 0px 12px 0px rgba(0,0,0,0.1)'};

  &:hover {
    ${({ displaySidebar }) => !displaySidebar && 'box-shadow: 8px 0px 12px 0px rgba(0,0,0,0.1)'};

    @media (min-width: 468px) {
      width: ${({ displaySidebar }) => !displaySidebar && '15rem'};
      ${ItemWrapper} {
        justify-content: ${({ displaySidebar }) => !displaySidebar && 'flex-start'};
        .beta {
          display: ${({ displaySidebar }) => (displaySidebar ? 'none' : 'inline')};
        }
      }
      ${ItemName} {
        display: ${({ displaySidebar }) => !displaySidebar && 'block'};
        margin-left: ${({ displaySidebar }) => !displaySidebar && '0.5rem'};
      }
      ${LifetimeSidebarBadge} {
        .badgeContainer {
          width: 90%;
          height: 13rem;

          svg {
            align-self: flex-start;
          }
        }

        .badgeText {
          display: flex;
        }
      }
    }
  }
  ::-webkit-scrollbar {
    width: 4px;
    height: 3px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #eaeced;
    &:hover {
      background: #d5e0f3;
    }
  }
  @media (max-width: 468px) {
    width: 5rem;
  }

  @media only screen and (max-width: 800px) {
    display: none;
  }
`
